/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Enable_SoundInputs */

const vi_station_enable_sound = /** @type {(inputs: Station_Enable_SoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bật âm thanh`)
};

/**

* @param {Station_Enable_SoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_enable_sound = /** @type {((inputs?: Station_Enable_SoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Enable_SoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_enable_sound(inputs)
});